"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function withModel(useModelOrUseModels, mapModelToProps) {
    return function (C) {
        var Wrapper = function (props) {
            var e_1, _a;
            var modelProps;
            if (Array.isArray(useModelOrUseModels)) {
                var models = [];
                try {
                    for (var useModelOrUseModels_1 = __values(useModelOrUseModels), useModelOrUseModels_1_1 = useModelOrUseModels_1.next(); !useModelOrUseModels_1_1.done; useModelOrUseModels_1_1 = useModelOrUseModels_1.next()) {
                        var useModel = useModelOrUseModels_1_1.value;
                        models.push(useModel());
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (useModelOrUseModels_1_1 && !useModelOrUseModels_1_1.done && (_a = useModelOrUseModels_1.return)) _a.call(useModelOrUseModels_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                modelProps = mapModelToProps(models, props);
            }
            else {
                var model = useModelOrUseModels();
                modelProps = mapModelToProps(model, props);
            }
            var componentProps = __assign(__assign({}, props), modelProps);
            return react_1.default.createElement(C, __assign({}, componentProps));
        };
        Wrapper.displayName = C.displayName + "Wrapper";
        return Wrapper;
    };
}
exports.withModel = withModel;
